import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import LocationChart from '../../components/chart/LocationChart';
import DefaultLoader from '../../components/loader/DefaultLoader';
import Form from 'react-bootstrap/Form';
import {useCookies} from 'react-cookie';
import dateSetting from '../../utils/dateSetting';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

function PitchLocationMain({profile, leagueType = 4201}) {
    const [cookies] = useCookies(['hiball_token']);
    let [loading, setLoading] = useState(false);
    let [damageData, setDamageData] = useState(null);
    let [zoneValue, setZoneValue] = useState('pitchCnt');
    let [filterValue, setFilterValue] = useState({type: 'total', count: 'total'});
    let {playerId, type, battingHand} = profile;
    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();

    let useLang = localStorage.getItem('language');

    useEffect(() => {
        if(leagueType === 4201) {
            let params = {
                recordType: 'digestRecord', recordName: 'selectPitchLogChart',
                seasons: season,
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
    
            if(type === 'batter') {
                params['batterIds'] = playerId;
            } else {
                params['pitcherIds'] = playerId;
            }
    
            axios({
                url : `${process.env.REACT_APP_API_URL}`, params
            }).then((result) => { 
                let pitchData = result['data']['result'];
                setDamageData(pitchData);
                setLoading(true);
            })
        } else {
            let params = {
                recordType: 'futuresRecordService', recordName: 'futuresTrackManLogRecord',
                seasons: season,
                // gameTypeCode: 4206,
                leagueTypeCodes: 'KBOFutures',
                authToken:JSON.stringify(cookies['hiball_token'])
            }

            if(type === 'batter') {
                params['batterIds'] = playerId;
            } else {
                params['pitcherIds'] = playerId;
            }
    
            axios({
                url : `${process.env.REACT_APP_API_URL}`, params
            }).then((result) => { 
                let pitchData = _.map(result['data']['result']['record'], (item, idx) => {
                    let {pitchPostion} = item;
                    let parseData = JSON.parse(pitchPostion);
                    item['pitchZoneX'] = parseData['pitchPositionX']*2;
                    item['pitchZoneY'] = parseData['pitchPositionY']*2;
                    item['before_decided_ball_count'] = item['strikes']+"-"+item['balls'];

                    return item;
                });

                let groupData = _.groupBy(pitchData, (item, idx) => {
                    const {taggedPitchType} = item;

                    if(taggedPitchType === 'Fastball' || taggedPitchType === 'Sinker') {
                        return 'faseBall';
                    } else if(taggedPitchType === 'ChangeUp' || taggedPitchType === 'Splitter') {
                        return 'fork'
                    } else if(taggedPitchType === 'Slider' || taggedPitchType === 'Cutter' || taggedPitchType === 'Curveball' || taggedPitchType === 'Sweeper') {
                        return 'slider/curve';
                    }
                });

                setDamageData(groupData);
                setLoading(true);
            })
        }
        
    }, [season]);

    if(!damageData) {
        return <DefaultLoader />
    }

    // if(Object.keys(damageData).length === 0) {
    //     return <DefaultLoader />
    // }

    function damageValueHandler(event) {
        let type = event.target.value;
        setFilterValue({...filterValue, type});
    }

    function damageCountHandler(event) {
        let count = event.target.value;
        setFilterValue({...filterValue, count});
    }

    function seasonHandler(event) {
        let value = event.target.value;
        setLoading(false);
        setSeason(value);
    }

    function zoneValueHandler(event) {
        let value = event.target.value;
        setZoneValue(value);
    }

    const style = {
        display: 'flex'
    }

    return (
        <>
        <Col id="pitchLocation" className="digestDivBox2" style={{position:'relative'}}>
            <div className="titleWrap">
                <div className="boxTitle" style={useLang === "en" ? {fontSize:"18px"} : {}}>
                    {t('pitchLocation')}{(leagueType === 4206) && '(T)'}
                </div>
                <div style={{position:'absolute', top: '7px', left: '175px'}}>
                    <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                        <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                            <option value={todaySeason-2}>{todaySeason-2}</option>
                            <option value={todaySeason-1}>{todaySeason-1}</option>
                            <option value={todaySeason}>{todaySeason}</option>
                        </Form.Select>
                    </Form.Group>
                </div>
                <div style={{position:'absolute', top: '7px', left: '260px'}}>
                    <Form.Group onChange={zoneValueHandler} style={{display:'inline-block', height: '29px'}}>
                        <Form.Select size="sm" defaultValue={'pitchCnt'}>
                            <option value='pitchCnt'>{t('pitches')}</option>
                            <option value='rate'>{t('percent')}</option>
                        </Form.Select>
                    </Form.Group>
                </div>
                <div style={{display:'inline-block', padding: '7px'}}>
                    <div style={style}>
                    {
                        type === 'batter' ?
                        (
                        <>
                        <div className="formTitle">{t('pitcherThrows')}</div>
                        <Form.Group onChange={damageValueHandler}>
                            <Form.Select size="sm" id="locationTypeFilter">
                                <option value="total">{t('all')}</option>
                                <option value="R">{t('throwRight')}</option>
                                <option value="L">{t('throwLeft')}</option>
                                <option value="S">{t('throwSideOrUnder')}</option>
                            </Form.Select>
                        </Form.Group>
                        </>
                        ) :
                        (
                        <>
                        <div className="formTitle">{t('batterHits')}</div>
                        <Form.Group onChange={damageValueHandler}>
                            <Form.Select size="sm" id="locationTypeFilter">
                                <option value="total">{t('all')}</option>
                                <option value="R">{t('hitRight')}</option>
                                <option value="L">{t('hitLeft')}</option>
                            </Form.Select>
                        </Form.Group>
                        </>
                        )
                    }
                    <div className="formTitle">{t('count')}</div>
                    <Form.Group onChange={damageCountHandler}>
                        <Form.Select size="sm" id="locationCountFilter">
                        <option value="total">{t('all')}</option>
                            <option value="first">{t("firstPitch")}</option>
                            <option value="2strike">2S</option>
                            <option value="pitcher">{t('pitcherCount')}</option>
                            <option value="batter">{t('batterCount')}</option>
                            <option value="full">{t('fullCount')}</option>
                        </Form.Select>
                    </Form.Group>
                    </div>
                </div>
            </div>
            <div className="imageWrap">
            {
                loading ?
                <>
                <LocationChart title={'fastballs'} playerType={type} battingHand={battingHand}
                data={damageData['faseBall']} name={'fastBall'} filter={filterValue}
                dataType={zoneValue} statYn={false}/>
                <LocationChart title={'breaking'} playerType={type} battingHand={battingHand}
                data={damageData['slider/curve']} name={'slider'} filter={filterValue}
                dataType={zoneValue} statYn={false}/>
                {/* <LocationChart title={'커브'} playerType={type}
                data={damageData['curve']} name={'curve'} filter={filterValue}/> */}
                <LocationChart title={'offspeed'} playerType={type} battingHand={battingHand}
                data={damageData['fork']} name={'fork'} filter={filterValue}
                dataType={zoneValue} statYn={false}/>
                </> :
                <div style={{height: '194px', width:'100%',textAlign:'center'}}><DefaultLoader /></div>
            }
            </div>
        </Col>
        </>
    )
}

export default PitchLocationMain;